import { defineMessages } from 'react-intl'

export default defineMessages({
    confirmSendOrderPrompt: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.confirmSendOrderPrompt',
        defaultMessage: 'Are you sure you want to send these orders?',
    },
    sendSuccess: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.sendSuccess',
        defaultMessage: 'Successfully sent {orderIds}',
    },
    sendError: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.sendError',
        defaultMessage: 'Error sending {orderIds}',
    }
})
